import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import loyalty_tiersDataTable from "./data/loyalty_tiersDataTable";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddLoyalty_tiersModal from "../../components/AddLoyalty_tiersModal"; // تأكد من المسار الصحيح
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { CircularProgress, Backdrop } from "@mui/material";

function Loyalty_tiers() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const [loading, setLoading] = useState(true);

  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
  };
  useEffect(() => {
    fetchUsers();
  }, []);
  const fetchUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(
        BASE_URL + "/administrator/loyalty-tiers",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setUsers(data.data || []);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };

  const { columns, rows } = loyalty_tiersDataTable(users, handleEditClick, fetchUsers);

  const filteredRows = rows.filter((row) =>
    row.name.toString().toLowerCase().includes(search.toLowerCase())
  );

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث
  }, [search]);

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AddLoyalty_tiersModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchUsers}
        initialData={currentUser}
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة مستويات الولاء
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              مستوى ولاء جديد
            </MDButton>
          </MDBox>

          <MDBox pt={3} px={2}>
            <TextField
              fullWidth
              label="بحث بالاسم المستوى"
              variant="outlined"
              size="small"
              sx={{ mb: 3 }}
              onChange={(e) => setSearch(e.target.value)}
            />
            <DataTable
              table={{ columns, rows: paginatedRows }}
              isSorted={false}
              entriesPerPage={false} // نعطل تقسيم الصفحات الداخلي
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            />

            {/* أزرار التحكم في الصفحات */}
            <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
              <MDButton
                onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                disabled={page === 0}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  color: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  minWidth: "50px",
                  mx: 1,
                  "&:hover": {
                    background: "linear-gradient(90deg, #b6842f, #d39d45)",
                  },
                }}
              >
                <ArrowBackIcon />
              </MDButton>

              <MDTypography
                variant="button"
                color="text"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mx: 3,
                  fontWeight: "bold",
                }}
              >
                الصفحة {page + 1} من {Math.ceil(filteredRows.length / rowsPerPage)}
              </MDTypography>

              <MDButton
                onClick={() =>
                  setPage((prev) =>
                    (prev + 1) * rowsPerPage >= filteredRows.length ? prev : prev + 1
                  )
                }
                disabled={(page + 1) * rowsPerPage >= filteredRows.length}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  color: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  minWidth: "50px",
                  mx: 1,
                  "&:hover": {
                    background: "linear-gradient(90deg, #b6842f, #d39d45)",
                  },
                }}
              >
                <ArrowForwardIcon />
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </>
  );
}

export default Loyalty_tiers;
